import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { getWorkOrdersToAssetDetails } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";
import { INITIAL_VALUES_MODAL } from "@/shared/work-orders-modals/models/ModalInitialValue";
import { get } from "react-hook-form";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchWorkOrders = ({ setIsLoading, setError }: Props) => {
	const {
		state: {
			assetSearchId,
			lastNWorkOrders,
			SearchText,
			TypeCode,
			WorkOrderStatusCode,
			CraftId,
		},
		actions: { setWorkOrdersRows, setWorkOrderSelectedRow },
	} = useAssetDetailsContext();

	return async () => {
		// Validate AssetId before making API call
		if (!assetSearchId || assetSearchId === 0) {
			setIsLoading(false);
			return;
		}

		setWorkOrdersRows([]);
		setIsLoading(true);
		const res = await getWorkOrdersToAssetDetails(
			assetSearchId as any,
			lastNWorkOrders,
			SearchText,
			TypeCode,
			WorkOrderStatusCode,
			CraftId,
		);
		if (res.ok) {
			const row = get(res, "data.tables[0].rows", []);
			setWorkOrdersRows(row);
			setWorkOrderSelectedRow(INITIAL_VALUES_MODAL);
			setIsLoading(false);
		} else {
			setError(res.message);
			setIsLoading(false);
		}
	};
};
